<style lang="scss" scoped>
/deep/ .comp-employee-hire-dialog {
    max-width: 560px;
}
</style>

<template>
    <div class="comp-employee-hire">
        <el-dialog title="手动入职" custom-class="c-el-dialog comp-employee-hire-dialog" :visible.sync="showDialog"
            :before-close="_close" :close-on-click-modal="false">
            <el-alert v-if="existArchive" class="mrgb10" :closable="false"
                :type="existArchive.status === 1 ? 'error' : 'warning'"
                :title="existArchive.status === 1 ? '该员工当前在职，不能重复办理入职' : '已存在离职档案，确认后将复用该档案入职'">
            </el-alert>
            <el-form :model="dialogData" :rules="formRules" :ref="formRefName" label-width="100px" size="small">
                <el-col :xs="24">
                    <el-form-item label="身份证号" prop="idNumber">
                        <el-input class="c-pw100" v-model="dialogData.idNumber" placeholder="请输入身份证号，自动识别已有档案"
                            clearable @blur="checkArchive"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24">
                    <el-form-item label="姓名" prop="name">
                        <el-input class="c-pw100" v-model="dialogData.name" placeholder="请输入姓名" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24">
                    <el-form-item label="手机号" prop="tel">
                        <el-input class="c-pw100" v-model="dialogData.tel" placeholder="请输入手机号" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24">
                    <el-form-item label="入职日期" prop="effectiveDate">
                        <el-date-picker class="c-pw100" v-model="dialogData.effectiveDate" type="date"
                            placeholder="请选择入职日期" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :xs="12">
                    <el-form-item label="运营区域">
                        <el-input class="c-pw100" v-model="dialogData.operationArea" placeholder="选填" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12">
                    <el-form-item label="职位">
                        <el-input class="c-pw100" v-model="dialogData.position" placeholder="选填" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12">
                    <el-form-item label="用工类型">
                        <el-input class="c-pw100" v-model="dialogData.employmentType" placeholder="选填" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12">
                    <el-form-item label="职业技能">
                        <el-input class="c-pw100" v-model="dialogData.skills" placeholder="选填" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12">
                    <el-form-item label="银行卡号">
                        <el-input class="c-pw100" v-model="dialogData.bankCardNo" placeholder="选填" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12">
                    <el-form-item label="开户行">
                        <el-input class="c-pw100" v-model="dialogData.bankName" placeholder="选填" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12">
                    <el-form-item label="合同到期">
                        <el-date-picker class="c-pw100" v-model="dialogData.contractExpireDate" type="date"
                            placeholder="选填" value-format="yyyy-MM-dd" :clearable="true"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :xs="24">
                    <el-form-item label="备注">
                        <el-input class="c-pw100" type="textarea" :rows="2" v-model="dialogData.remark"
                            placeholder="选填"></el-input>
                    </el-form-item>
                </el-col>
            </el-form>
            <span slot="footer">
                <el-button size="small" @click="_close()">取消</el-button>
                <el-button size="small" type="primary" @click="_save()">确认入职</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import enumConfigs from "@/mixins/enumConfigs"
import * as funEmployee from "@/api/employees"
import moment from "moment"

export default {
    name: "compEmployeeHire",
    mixins: [enumConfigs],
    data() {
        return {
            showDialog: false,
            // 已识别到的现有档案（null = 新员工）
            existArchive: null,
            defaultDialogData: {
                idNumber: "",
                name: "",
                tel: "",
                operationArea: "",
                position: "",
                employmentType: "",
                skills: "",
                bankCardNo: "",
                bankName: "",
                contractExpireDate: "",
                effectiveDate: "",
                remark: ""
            },
            dialogData: {},
            formRefName: "refEmployeeHire",
            formRules: {
                idNumber: [
                    { required: true, message: "请输入身份证号", trigger: ["blur"] },
                    { pattern: /^(\d{15}|\d{17}[\dXx])$/, message: "身份证号格式不正确", trigger: ["blur"] }
                ],
                name: [{ required: true, message: "请输入姓名", trigger: ["blur"] }],
                tel: [
                    { required: true, message: "请输入手机号", trigger: ["blur"] },
                    { pattern: /^\d{11}$/, message: "手机号格式不正确", trigger: ["blur"] }
                ],
                effectiveDate: [{ required: true, message: "请选择入职日期", trigger: ["change"] }]
            }
        }
    },
    methods: {
        open(row) {
            this.dialogData = JSON.parse(JSON.stringify(this.defaultDialogData))
            this.dialogData.effectiveDate = moment().format("YYYY-MM-DD")
            this.existArchive = null
            if (row && row.idNumber) {
                // 离职员工再次入职：回填档案信息
                this.applyArchive(row)
            }
            this.showDialog = true
        },
        // 回填档案信息并标记已识别
        applyArchive(archive) {
            this.existArchive = archive
            this.dialogData.idNumber = archive.idNumber
            this.dialogData.name = archive.name
            this.dialogData.tel = archive.tel
            this.dialogData.operationArea = archive.operationArea || ""
            this.dialogData.position = archive.position || ""
            this.dialogData.employmentType = archive.employmentType || ""
            this.dialogData.skills = archive.skills || ""
            this.dialogData.bankCardNo = archive.bankCardNo || ""
            this.dialogData.bankName = archive.bankName || ""
            this.dialogData.contractExpireDate = archive.contractExpireDate ? moment(archive.contractExpireDate).format("YYYY-MM-DD") : ""
        },
        // 身份证号失焦时自动识别已有档案
        checkArchive() {
            let idNumber = (this.dialogData.idNumber || "").trim()
            if (!idNumber || (this.existArchive && this.existArchive.idNumber === idNumber.toUpperCase())) {
                return
            }
            funEmployee.GetEmployeeArchives({ keywords: idNumber, page: 1, size: 20 }).then(response => {
                // 输入已变化时丢弃过期响应
                if ((this.dialogData.idNumber || "").trim() !== idNumber) {
                    return
                }
                let archive = (response.items || []).find(x => x.idNumber === idNumber.toUpperCase())
                if (archive) {
                    this.applyArchive(archive)
                } else {
                    // 从已有档案切换到另一个新身份证号时，清掉上一个人的回填资料
                    if (this.existArchive) {
                        this.clearArchiveFields()
                    }
                    this.existArchive = null
                }
            })
        },
        // 清空档案回填字段（保留身份证号/入职日期/备注）
        clearArchiveFields() {
            ["name", "tel", "operationArea", "position", "employmentType", "skills", "bankCardNo", "bankName", "contractExpireDate"]
                .forEach(key => {
                    this.dialogData[key] = ""
                })
        },
        _save() {
            this.$refs[this.formRefName].validate(valid => {
                if (!valid) {
                    return
                }
                if (this.existArchive && this.existArchive.status === 1) {
                    this.errorMsg("该员工当前在职，不能重复办理入职!")
                    return
                }
                window.$common.fullLoading()
                funEmployee.CreateEmployeeEmploymentRecord({
                    type: this.valEmployeeRecordTypeHire(),
                    idNumber: this.dialogData.idNumber.trim(),
                    name: this.dialogData.name.trim(),
                    tel: this.dialogData.tel.trim(),
                    operationArea: this.dialogData.operationArea,
                    position: this.dialogData.position,
                    employmentType: this.dialogData.employmentType,
                    skills: this.dialogData.skills,
                    bankCardNo: this.dialogData.bankCardNo,
                    bankName: this.dialogData.bankName,
                    contractExpireDate: this.dialogData.contractExpireDate || null,
                    effectiveDate: this.dialogData.effectiveDate,
                    remark: this.dialogData.remark
                }).then(() => {
                    this.commonSuccess(this.existArchive ? "入职成功，已复用原有档案!" : "入职成功!")
                })
            })
        },
        _close() {
            this.showDialog = false
            this.$nextTick(() => {
                if (this.$refs[this.formRefName]) {
                    this.$refs[this.formRefName].resetFields()
                }
            })
        },
        commonSuccess(val) {
            this.alert(val || "操作成功!").then(() => {
                window.$common.closeFullLoading()
                this._close()
                this.refreshData()
            })
        },
        refreshData() {
            this.$emit("refreshData", this.dialogData)
        }
    }
}
</script>
